import { render, staticRenderFns } from "./RefundDialog.vue?vue&type=template&id=51d31273&scoped=true"
import script from "./RefundDialog.vue?vue&type=script&lang=js"
export * from "./RefundDialog.vue?vue&type=script&lang=js"
import style0 from "./RefundDialog.vue?vue&type=style&index=0&id=51d31273&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d31273",
  null
  
)

export default component.exports